import { useEffect, useState } from 'react'
import { isBrowser } from '../utils/generic'

const useIsLandscape = (isMobile = true) => {
  const [isLandscape, setIsLandscape] = useState(false)

  useEffect(() => {
    if (!isMobile || !isBrowser() || !window.screen) return

    const onOrientationChange = () => {
      setTimeout(() => {
        const landscape =
          window?.screen?.orientation?.type?.startsWith('landscape')
        setIsLandscape(landscape)
      }, 100)
    }

    onOrientationChange()

    window.addEventListener('orientationchange', onOrientationChange)

    return () => {
      window.removeEventListener('orientationchange', onOrientationChange)
    }
  }, [isMobile])

  return isLandscape
}

export default useIsLandscape
